/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

// Fetches media solution list for inventory
const getMediaSolutionList = async (page: number, size: number, sort: any, order: any, keyword: any, status?: string, lot?: string, mediaType?: string, fromDate?: string, toDate?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_solution_batch?page=${page}&size=${size}&sort=${sort}&order=${order}${keyword ? `&keyword=${keyword}` : ''}${status ? `&status=${status}` : ''}${lot ? `&batch_name=${lot}` : ''}${mediaType ? `&media_name=${mediaType}` : ''}${fromDate ? `&from_date=${fromDate}` : ''}${toDate ? `&to_date=${toDate}` : ''}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches media solution statistics for dashboard cards
const getMediaSolutionStats = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_solution/statistics`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

  // Fetches batch codes for the filter dropdown
const getBatchCodes = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_solution_batch?page=1&size=1000&sort=id&order=desc`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

  // Fetches solution types for the filter dropdown
const getMediaSolutionTypeList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_solutions?page=1&size=100&sort=id&order=desc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches media solution lot details (Batch Details screen)
const getMediaSolutionLotDetails = async (batchId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_solution_batch_lot_details?page=1&size=50&sort=id&order=asc&solution_batch_id=${batchId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


// Fetches solution product definitions 
const getMediaSolutionProductDefinitions = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_solution/list?sort=id&order=desc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Creates a new media solution lot
const createMediaSolution = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/media/create_solution_batch`,
      payload,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

export const MediaSolutionService = {
  getMediaSolutionList,
  getMediaSolutionStats,
  getBatchCodes,
  getMediaSolutionLotDetails,
  getMediaSolutionProductDefinitions,
  getMediaSolutionTypeList,
  createMediaSolution,
};